<script>
import { Pie , mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ['options', 'data'],
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>
